import React, { CSSProperties } from 'react';
import { Avatar, styled } from '@mui/material';

import DefaultPlant from '../../../assets/images/default-image/plant_default.png';

interface ContainerProps {
  orgColor?: CSSProperties['color'];
  disabled: boolean;
}

//prettier-ignore
const Container = styled('div', { shouldForwardProp: prop => prop !== 'orgColor' })<ContainerProps>`
  display: flex;
  align-items: center;
  color: white;
  padding: 12px 10px;
  cursor: pointer;
  pointer-events: ${({ disabled }) => (disabled === true ? 'none' : 'auto')};
  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
  & .info {
    flex: 1;
    min-width: 0;
    div {
      ${({ theme }) => ({ ...theme.typography.body2 })}
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      &:nth-of-type(2) {
        ${({ theme }) => ({ ...theme.externalTypography.body3 })}
        color: ${({ theme }) => theme.color.secondary.$60};
        &:before {
          display: inline-block;
          content: '';
          width: 6px;
          height: 14px;
          border-radius: 3px;
          background: ${({ orgColor }) =>
            orgColor ? orgColor : 'transparent'};
          margin-right: 6px;
        }
      }
      &.org {
        display: flex;
        align-items: center; 
      }
      & > span{
        margin-left: 5px;
        color: ${({theme})=> theme.color.secondary.$60};
        font-family: 'Noto Sans';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        max-width: 305px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
`;

interface PlantItemProps {
  onClick: () => void;
  name: string;
  orgName: string | undefined;
  orgColor?: CSSProperties['color'];
  imageURL: string | null;
  dasIds: string[];
  disabled: boolean;
}

const PlantItem: React.FC<PlantItemProps> = ({
  onClick,
  name,
  dasIds,
  orgName,
  orgColor,
  imageURL,
  disabled,
}) => {
  return (
    <>
      <Container orgColor={orgColor} onClick={onClick} disabled={disabled}>
        <Avatar
          variant="square"
          sx={{
            width: '40px',
            height: '40px',
            borderRadius: '4px',
            objectFit: 'cover',
            marginRight: '10px',
          }}
          src={imageURL ?? ''}
        >
          <Avatar
            src={DefaultPlant}
            alt="plant beeinventor"
            variant="square"
            sx={{
              width: '40px',
              height: '40px',
              borderRadius: '4px',
              objectFit: 'cover',
            }}
          />
        </Avatar>
        <div className="info">
          <div
            title={`${name}${
              dasIds.length > 0 ? ` (${dasIds.join(', ')})` : ''
            }`}
          >
            {name}{' '}
            {dasIds.length > 0 && <span>{`(${dasIds.join(', ')})`}</span>}
          </div>
          <div className="org" title={orgName}>
            {orgName}
          </div>
        </div>
      </Container>
    </>
  );
};

export default PlantItem;
